import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { BenutzermanagementAPIService } from '../api/benutzermanagement/benutzermanagement-api.service';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private benutzermanagementApi: BenutzermanagementAPIService,
    private router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.benutzermanagementApi.isAuthenticated().pipe(
      take(1),
      map((l) => {
        if (!l) {
          this.benutzermanagementApi.setNextAfterLogin(state.url);
          return this.router.createUrlTree(['']);
        }
        return true;
      }),
    );
  }
}
